var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 7.49935C5.83301 7.03911 6.2061 6.66602 6.66634 6.66602H13.333C13.7932 6.66602 14.1663 7.03911 14.1663 7.49935C14.1663 7.95959 13.7932 8.33268 13.333 8.33268H6.66634C6.2061 8.33268 5.83301 7.95959 5.83301 7.49935Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 10.8333C5.83301 10.3731 6.2061 10 6.66634 10H11.6663C12.1266 10 12.4997 10.3731 12.4997 10.8333C12.4997 11.2936 12.1266 11.6667 11.6663 11.6667H6.66634C6.2061 11.6667 5.83301 11.2936 5.83301 10.8333Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00033 4.16667C4.5583 4.16667 4.13438 4.34226 3.82181 4.65482C3.50925 4.96738 3.33366 5.39131 3.33366 5.83333V12.5C3.33366 12.942 3.50925 13.366 3.82181 13.6785C4.13437 13.9911 4.5583 14.1667 5.00033 14.1667H6.66699C7.12723 14.1667 7.50033 14.5398 7.50033 15V16.0282L10.4049 14.2854C10.5344 14.2077 10.6826 14.1667 10.8337 14.1667H15.0003C15.4424 14.1667 15.8663 13.9911 16.1788 13.6785C16.4914 13.366 16.667 12.942 16.667 12.5V5.83333C16.667 5.39131 16.4914 4.96738 16.1788 4.65482C15.8663 4.34226 15.4424 4.16667 15.0003 4.16667H5.00033ZM2.6433 3.47631C3.26842 2.85119 4.11627 2.5 5.00033 2.5H15.0003C15.8844 2.5 16.7322 2.85119 17.3573 3.47631C17.9825 4.10143 18.3337 4.94928 18.3337 5.83333V12.5C18.3337 13.3841 17.9825 14.2319 17.3573 14.857C16.7322 15.4821 15.8844 15.8333 15.0003 15.8333H11.0645L7.09574 18.2146C6.8383 18.369 6.51767 18.3731 6.25641 18.2252C5.99515 18.0772 5.83366 17.8002 5.83366 17.5V15.8333H5.00033C4.11627 15.8333 3.26842 15.4821 2.6433 14.857C2.01818 14.2319 1.66699 13.3841 1.66699 12.5V5.83333C1.66699 4.94928 2.01818 4.10143 2.6433 3.47631Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.49fc35499845399f8fdb8684835bbac2.svg";
export { ForwardRef as ReactComponent };